import { useMemo } from 'react';
import { Goal } from 'shared/types/goal';
import { MetricEntry, MetricEntryMode } from 'shared/types/goal-metric';
import { ID } from 'shared/types/id';
import { calculateMetricEntryValue } from 'shared/utils/calculate-metric-entry-value';
import { formatDateKey } from 'shared/utils/format-date-key';

import { useGoalById } from './use-goal-by-id';

export const useGoalMetricDayProgress = (goal?: Goal) =>
  useMemo(() => {
    const uniqueEntries = new Map<string, MetricEntry>();

    goal?.metric?.entries?.forEach((entry) => {
      const dateKey = formatDateKey(entry.date);
      const existingUniqueEntry = uniqueEntries.get(dateKey);

      if (
        existingUniqueEntry &&
        existingUniqueEntry.date.getTime() > entry.date.getTime()
      ) {
        return;
      }

      uniqueEntries.set(dateKey, {
        ...entry,
        value: calculateMetricEntryValue(
          entry.id,
          goal?.metric?.entries!,
          goal?.metric?.startValue ?? 0,
        ),
        mode: MetricEntryMode.Absolute,
      });
    });

    return Array.from(uniqueEntries.values()).sort(
      (entryA, entryB) => entryA.date.getTime() - entryB.date.getTime(),
    );
  }, [goal?.metric?.entries, goal?.metric?.startValue]);

export const useGoalMetricDayProgressById = (id?: ID) => {
  const goal = useGoalById(id);

  return useGoalMetricDayProgress(goal);
};
